var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',_vm._b({},'path',{
            class : 'tool_svgElem',
            id : _vm.tool.id + '-body',
            d : _vm.d_path()
        },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }